import { useQuery } from "@tanstack/react-query";
import { commercialsApi } from "../api/commercials";
import { useState } from "react";

export const useForecast = (projectId: string | undefined) => {

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(25);

    const changePage = (newPage: number) => {
        setPage(newPage);
    };

    const changeRowsPerPage = (newLimit: number) => {
        setPage(1);
        setLimit(newLimit);
    };

    const { data, isLoading, isError, error } = useQuery({
        queryKey: ["project-forecast", projectId, page, limit],
        queryFn: () => commercialsApi.fetchForecastTable({ projectId, page, limit }),
    });

    return { data: data?.data?.rows, pagination: data?.data?.pagination, isLoading, isError, error, changePage, changeRowsPerPage };

};